module.exports = __webpack_public_path__ + "assets/img/all_award_btn.85787a23.png";